<template>
  <div v-if="question.isShow" class="question-item">
    <div class="question-title">

      <i v-if="question.tipColor == 1">
        <img src="./image/red.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 2">
        <img src="./image/yellow.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 3">
        <img src="./image/green.png" alt="">
      </i>
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题：</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <div class="qs-img-preview">
      <img :src="question.pictureUrl" alt="">
    </div>
    <div class="question-option">
      <span class="completionText">{{ question.completeConfig.completeTextArr[0].text1 }}</span>
      <textarea class="complete-textarea" v-model="question.value"
                :type="question.completeConfig.completeType"></textarea>
      <span class="completionText">{{ question.completeConfig.completeTextArr[0].text2 }}</span>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'questionCompletion',
  props: {
    question: {required: true},
    patientId: {required: true}
  },
  watch: {
    'question.value': {
      handler(val) {
        // if()
      },
      deep: true,
      immediate: true
    },
    'question.isShow': {
      handler(val, oldVal) {
        if (!val && oldVal) {
          this.question.value = ""
          // this.deleteAnswer()
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapGetters([
      'currentPage'
    ])
  },
  destroyed() {
    // console.log('deleteAnswer',this.currentPage, this.question);
    // if(this.$route.path == '/callPatient' && this.currentPage == this.question.pageNumber) {
    //   console.log('deleteAnswer');
    //   this.deleteAnswer()
    // } 
  },
  mounted() {
    this.getPicture()
  },
  methods: {
    getPicture() {
      if (this.question.pictureUrl && this.question.pictureUrl.indexOf('http') == -1) {
        this.$store.dispatch('getPicture', {url: [this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },
    selectHandler(item) {
      this.question.options.forEach(v => {
        v.selected = false
      })
      item.selected = true
      this.question.value = item
    },
    checkIsFill() {
      if (this.question.isShow) {
        if (this.question.isMust) {
          if (this.question.value) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return true
      }
    },
    saveAnswer() {
      return new Promise((resolve => {
        var params = {
          operatorId: localStorage.getItem('huidrUserId'),
          questionInfo: this.question.id,
          questionnaireNewId: this.question.questionnaireNewId,
          answerInfo: this.question.value || "",
          id: this.question.patientAnswerInfoId || null,
          patientId: this.patientId,
          questionType: this.question.type || null,
        }
        if (this.$route.query.abnormal == '5') {
          params.isRecord = true
        } else {
          params.isRecord = false
        }
        if (this.question.patientAnswerInfoId) {
          this.$store.dispatch('updateQuestionAnswer', params)
              .then(() => {
                resolve()
              })
        } else {
          this.$store.dispatch('saveQuestionAnswer', params)
              .then((res) => {
                // console.log(res);
                this.question.patientAnswerInfoId = res.retValue.id

                // this.question.patientAnswerInfoId = res.retValue.id
                resolve()
              })
        }
      }))
      // this.$store.dispatch('saveQuestionAnswer',)
    },
    deleteAnswer() {
      var params = {
        questionNewId: this.question.questionnaireNewId,
        answerInfoId: this.question.patientAnswerInfoId || null,
      }
      console.log('deleteAnswer', this.question, this.question.patientAnswerInfoId);
      if (this.question.patientAnswerInfoId) {
        this.$store.dispatch('deleteQuestionAnswer', params)
            .then(res => {
              if (res.status == 0) {
                // this.question.patientAnswerInfoId = null 4,032,000/210,000
                this.question.value = null
                this.question.answerInfo = null
              } else {

              }
            })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "questionCommon";

.question-option {
  display: flex;

  .option-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .option-other {
  }

  .complete-textarea {
    width: 60%;
    border: 1px solid #d8d8d8;
  }
}


</style>